import Relay from 'react-relay';
/**
*  New musicPlayer mutation
*/
export default class NewMusicPlayerMutation extends Relay.Mutation {
  /**
  *  Mutation
  */
  getMutation() {
    return Relay.QL`mutation Mutation{
      newMusicPlayer
    }`;
  }
  /**
  *  Variables
  */
  getVariables() {
    return {
      musicPlayer: {
        ...this.props.musicPlayer
      }
    };
  }
  /**
  *  Fat query
  */
  getFatQuery() {
    return Relay.QL`
      fragment on newMusicPlayerPayload @relay(pattern: true){
        clientMutationId,
        viewer{
            id
        }
        musicPlayer {
            id, 
            name,
            description, 
            status,
            accessMinutes {
                before,
                after
            }
            allowUserAccess
            infrastructures {
                id
            }
            externalId
            maximumVolume
        }
      }
    `;
  }

  /**
  *  Config
  */
  getConfigs() {
    return [{
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          viewer: this.props.viewer.id,
        },
    }];
  }

  static fragments = {
    viewer: () => Relay.QL`
      fragment on Viewer {
          id
      }
    `,
  };
}



// WEBPACK FOOTER //
// ./src/mutations/Venue/NewMusicPlayerMutation.js